/*
 * *****************************************************************************
 *  Copyright (C)  Motorola Solutions, INC.
 *  All Rights Reserved.
 *  Motorola Solutions Confidential Restricted.
 *  ******************************************************************************
 */

import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { UpdateService } from './core/services/update.service';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'msi-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [CommonModule, RouterOutlet]
})
export class AppComponent {
    constructor(protected updateService: UpdateService) {
    }
}
